export default function isSafeClassName(className) {
  return className.indexOf('ad') === -1;
}